module.exports = __webpack_public_path__ + "static/media/home_bg_wide.c6a48354.png";